<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'patient-history' }" ripple>{{ $t('patient_history') }}</v-tab>
      <v-tab :to="{ name: 'self-referral' }" ripple>{{ $t('self_referral_list') }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentView: 'nongtungjai-patient-history'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/AdminMenu.vue